<!--Add Button-->
<button class="pulse" style="margin-left:43%" (click)="openModal()">Create Your Own Opportunity</button>
<!--Add Opportunity-->
<div id="myModal" class="modal" style="display:none;" >
  <div class="modal-dialog" style="width: 80%;">
    <div class="modal-content">
      <!-- Modal Header -->
      <div class="modal-header">
        <h4 class="modal-title">Add Opportunity</h4>
      
       
        <button type="button" class="close" (click)="closeModal()">&times;</button>
      </div>
      
      <!-- Modal Body -->
      <div class="modal-body">
        <small>Note : Those informations will be public! </small><br><br>
        <form [formGroup]="form" (ngSubmit)="onSubmit()">
          <div class="form-group">
            <label for="title">Title</label>
            <input type="text" formControlName="title" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.title.errors }" />
            <div *ngIf="submitted && f.title.errors" class="invalid-feedback">
              <div *ngIf="f.title.errors.required">title is required</div>
            </div>
          </div>
          <div class="form-group">
            <label for="description">Description</label>
            <textarea formControlName="description" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.description.errors }"></textarea>
            <div *ngIf="submitted && f.description.errors" class="invalid-feedback">
              <div *ngIf="f.description.errors.required">Description is required</div>
            </div>
          </div>
          
          <div class="form-group">
            <label for="email">Email</label>
            <input type="email" formControlName="email" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.email.errors }" />
            <div *ngIf="submitted && f.email.errors" class="invalid-feedback">
              <div *ngIf="f.email.errors.required">Email is required</div>
              <div *ngIf="f.email.errors.email">Invalid email format</div>
            </div>
          </div>
          <div class="form-group">
            <label for="numtlf">Phone Number</label>
            <input type="number" formControlName="numtlf" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.numtlf.errors }" />
            <div *ngIf="submitted && f.numtlf.errors" class="invalid-feedback">
              <div *ngIf="f.numtlf.errors.required">Phone Number is required</div>
              <div *ngIf="f.numtlf.errors.eightDigit">Phone Number must be 8 digits long</div>
            </div>
            
          </div>
          
          <div class="form-group">
            <label for="image">Image</label>
            <input type="file" formControlName="image" accept="image/*" class="form-control" [ngClass]="{ 'is-invalid': submitted && f.image.errors }" (change)="onFileSelected($event)" />

            <div *ngIf="submitted && f.image.errors" class="invalid-feedback">
              <div *ngIf="f.image.errors.required">Image is required</div>
            </div>
          </div>
          
            
         
          
         
          <div class="form-group">
          <button class="btn btn-outline-dark" type="submit">Add</button>
          <a class="btn btn-link" type="reset" href="/home/opportunities" (click)="closeModal()">Cancel</a>
          </div>
          
          </form>
          </div>
          </div>
          
            </div>
          </div>



 <!--Opportunities-->
 <div class="blog-slider5">
  <h4 style="text-align: center;">Here Is {{nOpportunity}} Opportunities </h4>
  <br>
  <br>
  <div class="container" >
    <div class="row">
      <div  *ngFor="let opportunities of ListOpportunity; let i of index" >
        <div class="main-card" style="width: 100%;" >
          <div class="cards"  >
            <div class="card" style="width: 336px; height: 355px;">

              <div class="content">
                <li style="list-style-type: none;">
                 <!-- <img src="http://localhost:9091/User/{{ posts.user.profileImage }}" style="width: 50px; height: 50px; border-radius: 50%; border: 2px solid #5A54FF; display: inline;" alt=""/>
                  <a class="nav-link" style="font-weight: bold; display: inline; color: black; ">
                    <i class="ion-md-power"></i> {{posts.user.nom}} {{posts.user.prenom}}
                  </a>-->
                  <a (click)="openalert(contentalert); setOpportunityId(opportunities._id) " [hidden]="hideSupp(opportunities.user._id)" [hidden]="hideUpp(opportunities.user._id)">
                    <fa-icon style="color: red;" [icon]="faTrash"  class="material-icons"></fa-icon>
                  </a>
                  <a [hidden]="hideform" (click)="topFunction()" [routerLink]="['/updateopportunity',opportunities._id]" [hidden]="hideUpp(opportunities.user._id)" [hidden]="hideUpp(opportunities.user._id)">
                    <fa-icon style="color: blue;" [icon]="faPencilAlt"  class="material-icons"></fa-icon>
                  </a>
                  <br>
                
                 <!--<small>Published on : {{posts.date}}</small>--> 
                </li>
                <div class="img" style="border:2px red !important;">
                  <img src="http://localhost:9091/Opportunity/{{ opportunities.image }}" style="width: 270px; height: 180px;" alt="Opportunity Picture" />

                </div>
                <div class="name" style="hyphens: none; color:#1B2559 ; margin-bottom: -5px;">
                  {{ opportunities.title | slice:0:10 }}
                </div>
                
                
                <p style="width: 80%; height: 70px; color: #a3aed0; margin-bottom: 27px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">
                  {{ opportunities.description | slice:0:100 }}{{ opportunities.description.length > 100 ? '...' : '' }}
                </p>
               
                <a style="color: black;  margin-left: 65%; margin-top: -130px;">
                  
           
                 
                
                </a>
                
                 <!--
                <a style=" font-size: large; margin-left: -80%;margin-top: -18%;" (click)="likePost(posts._id)"  href="/home/posts">
                  <i class="fa-sharp fa-solid fa-heart fa-beat-fade" style="color: #000000;"></i>
                </a>
               <a style=" font-size: large; margin-left: -65%; margin-top: -6.3%; " (click)="dislikePost(posts._id)"  href="/home/posts">
                  <fa-icon style="color: #5A54FF;" [icon]="faThumbsDown"  class="material-icons"></fa-icon>
                </a>-->
                  
                  
                <br>
                <div style="margin-left: 65px; margin-top: 35px;"> <button class="custom-button" (click)="setOpportunityId(opportunities._id)" [routerLink]="'/home/opportunities/opportunity'" >See More</button></div>
                </div>
               
                <br>
              </div>
              <br>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>


  <!--Archeive-->
<ng-template #contentalert let-modal>
  <div class="modal-header">
    <h5 style="color: #000000; text-align: center;" class="modal-title" id="modal-basic-title">Are You Sur to Archeive this Opportunity ?</h5>
    <a href="/home/opportunities">
      <button type="button" class="btn-close" aria-label="Close" (click)="modal.dismiss('Cross click')"></button>
    </a>
  </div>
  <div class="modal-body" >
    <form>
      <div class="form-group" style="align-items: center;">
        <a style="color: red;" href="/home/opportunities" class="btn btn-default" (click)="ArcheiveOpportunity(); modal.dismiss('Cross click')">Confirm</a>
        <a style="color: green;" class="btn btn-link" class="btn btn-default" href="/home/opportunities" (click)="modal.dismiss('Cross click')">Cancel</a>
      </div>
    </form>
  </div>
</ng-template>
